{
  "AGENT_BOTS": {
    "HEADER": "Bots",
    "LOADING_EDITOR": "Loading editor...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try. You can manage your bots from this page or create new ones using the 'Add Bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "GLOBAL_BOT": "System bot",
    "GLOBAL_BOT_BADGE": "System",
    "AVATAR": {
      "SUCCESS_DELETE": "Bot avatar deleted successfully",
      "ERROR_DELETE": "Error deleting bot avatar, please try again"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Select an agent bot",
      "DESC": "Assign an Agent Bot to your inbox. They can handle initial conversations and transfer them to a live agent when necessary.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Update",
      "DISCONNECT": "Disconnect bot",
      "SUCCESS_MESSAGE": "Successfully updated the agent bot.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Successfully disconnected the agent bot.",
      "ERROR_MESSAGE": "Could not update the agent bot. Please try again.",
      "DISCONNECTED_ERROR_MESSAGE": "Could not disconnect the agent bot. Please try again.",
      "SELECT_PLACEHOLDER": "Select bot",
      "COUNTRY_BOTS": {
        "TITLE": "Bots by country",
        "DESC": "This inbox serves several countries. A conversation goes to the bot of its country: by the Kaufland store, by the marketplace of the Allegro order, otherwise by the language the customer writes in. Every other conversation goes to the default bot above.",
        "COUNTRY": "Select country",
        "BOT": "Select bot",
        "ADD": "Add bot for a country",
        "REMOVE": "Remove",
        "DEFAULT_REQUIRED": "Select a default bot first. A country's bot only replaces it for that country.",
        "DISCONNECT_ALL": "Disconnect all bots"
      }
    },
    "ADD": {
      "TITLE": "Add Bot",
      "CANCEL_BUTTON_TEXT": "Cancel",
      "API": {
        "SUCCESS_MESSAGE": "Bot added successfully.",
        "ERROR_MESSAGE": "Could not add bot. Please try again later."
      }
    },
    "LIST": {
      "404": "No bots found. You can create a bot by clicking the 'Add Bot' button.",
      "LOADING": "Fetching bots...",
      "TABLE_HEADER": {
        "DETAILS": "Bot Details",
        "URL": "Webhook URL"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Delete",
      "TITLE": "Delete bot",
      "CONFIRM": {
        "TITLE": "Confirm Deletion",
        "MESSAGE": "Are you sure you want to delete {name}?",
        "YES": "Yes, Delete",
        "NO": "No, Keep"
      },
      "API": {
        "SUCCESS_MESSAGE": "Bot deleted successfully.",
        "ERROR_MESSAGE": "Could not delete bot. Please try again."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Edit",
      "TITLE": "Edit bot",
      "API": {
        "SUCCESS_MESSAGE": "Bot updated successfully.",
        "ERROR_MESSAGE": "Could not update bot. Please try again."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Bot avatar"
      },
      "NAME": {
        "LABEL": "Bot name",
        "PLACEHOLDER": "Enter bot name",
        "REQUIRED": "Bot name is required"
      },
      "DESCRIPTION": {
        "LABEL": "Description",
        "PLACEHOLDER": "What does this bot do?"
      },
      "WEBHOOK_URL": {
        "LABEL": "Webhook URL",
        "PLACEHOLDER": "https://example.com/webhook",
        "REQUIRED": "Webhook URL is required"
      },
      "ERRORS": {
        "NAME": "Bot name is required",
        "URL": "Webhook URL is required",
        "VALID_URL": "Please enter a valid URL starting with http:// or https://"
      },
      "CANCEL": "Cancel",
      "CREATE": "Create Bot",
      "UPDATE": "Update Bot"
    },
    "WEBHOOK": {
      "DESCRIPTION": "Configure a webhook bot to integrate with your custom services. The bot will receive and process events from conversations and can respond to them."
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot"
    }
  }
}
